import { useState } from 'react'
import { Box, Typography, useMediaQuery, useTheme } from '@material-ui/core'
import Banner from 'baby-ui/foundation/Banner/Banner'
import Link from 'baby-ui/foundation/Link/Link'
import { ReplacementPartsModal } from './components'

export const ReplacementPartsBanner = () => {
  const theme = useTheme()

  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  const [dialogOpen, setDialogOpen] = useState(false)
  const [hover, setHover] = useState(false)
  const onClick = () => setDialogOpen(true)

  const mobileCopy = (
    <>
      <Typography>
        Order your pump and get <b>FREE</b> replacement parts once baby has
        arrived!
      </Typography>
      <Typography>
        <span>&nbsp;&nbsp;</span>
        <span style={{ fontSize: '14px' }}>Exclusions apply.</span>
      </Typography>
    </>
  )

  const desktopCopy = (
    <Typography>
      Order your pump and get <b>FREE</b> replacement parts once baby has
      arrived!
      {!isMobile && <span>&nbsp;&nbsp;</span>}
      <span style={{ fontSize: '14px' }}>Exclusions apply.</span>
    </Typography>
  )

  return (
    <>
      <ReplacementPartsModal
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
      />
      <Link
        underline="none"
        onClick={onClick}
        style={{ cursor: 'pointer', color: theme.palette.common.white }}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        <Banner>
          <Box
            display="flex"
            flexDirection={isMobile ? 'column' : 'row'}
            justifyContent="center"
            alignItems="center"
            textAlign="center"
            maxWidth="460px"
            margin="auto"
            borderBottom={
              hover && !isMobile ? 1 : `1px solid ${theme.palette.primary.main}`
            }
          >
            {isMobile ? mobileCopy : desktopCopy}
          </Box>
        </Banner>
      </Link>
    </>
  )
}
